import { Dialog, DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';

export interface DeleteFfdNoteModalComponentData {}

export interface DeleteFfdNoteModalComponentResult {
  deleteFfdNote: boolean;
}

@Component({
  selector: 'lib-delete-ffd-note-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, SvgIconComponent],
  templateUrl: './delete-ffd-note-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteFfdNoteModalComponent {
  public dialogData: DeleteFfdNoteModalComponentData = inject(DIALOG_DATA);
  public dialog = inject(Dialog);
  private readonly dialogRef = inject(DialogRef);

  public onCloseDialog(): void {
    this.dialogRef.close({ deleteFfdNote: false });
  }

  public onDeleteNoteClick(): void {
    this.dialogRef.close({ deleteFfdNote: true });
  }
}
